import { MutationOptions, useMutation } from '@tanstack/react-query';
import { useToast } from '@givebutter/primitives/toast';
import { refreshQuickBooksMapping } from 'api/quickBooks';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';
import { queryClient } from 'queries/queryClient';
import { GivebutterAxiosError } from 'types/error';

const useQuickBooksRefreshMapping = (options?: MutationOptions<unknown, GivebutterAxiosError>) => {
    const { onSuccess, onError, ...restOptions } = options || {};
    const { accountId } = useCurrentAccount();
    const { success, error } = useToast();

    return useMutation<unknown, GivebutterAxiosError>({
        mutationFn: () => refreshQuickBooksMapping(accountId),
        onSuccess: (data, variables, context) => {
            onSuccess?.(data, variables, context);
            success('QuickBooks reference details refreshed!');
            queryClient.invalidateQueries({
                queryKey: accountQueryKeys.quickBooksDetails(accountId),
            });
        },
        onError: (e, variables, context) => {
            onError?.(e, variables, context);
            error(e.response?.data?.message ?? 'Unknown error');
        },
        ...restOptions,
    });
};

export { useQuickBooksRefreshMapping };
